/**
 * Decode a base64 string produced by `encodeBase64Json` back into a JSON
 * value. Works in both browsers and Node.js (no `Buffer`).
 */
export const decodeBase64Json = (base64: string): unknown => {
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes));
};
